<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_inventory'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to View Store</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  storedetailMethods,
  storedetailComputed,
  inventoryItemMethods,
  inventoryItemComputed,
  inventoryUnitMethods,
  inventoryUnitComputed,
  requisitiondetailComputed,
  requisitiondetailMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "View Requisition Orders",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Requisition Order",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "View Requisition Order", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "unit", label: "Unit", visible: true },
        { key: "item", label: "Item", visible: true },
        { key: "quantity", label: "Quantity", visible: true },
        { key: "takenby", label: "Taken By", visible: true },
        { key: "description", label: "Description", visible: true },
        { key: "addedby", label: "Added by", visible: true },
        { key: "created_at", label: "Added on", visible: true },
      ],

      id: "",
      unit: "",
    };
  },
  computed: {
    ...storedetailComputed,
    ...inventoryItemComputed,
    ...requisitiondetailComputed,
    ...inventoryUnitComputed,
    List() {
      return this.requisitiondetails.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.requisitiondetails.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.requisitiondetails.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    //   this.fetchStoredetails();
    this.fetchRequisitiondetails();
    this.fetchInventoryitems();
    this.fetchInventoryunits();
    this.TotalRows = this.requisitiondetails.length;
    this.isBusy = false;
  },
  methods: {
    ...storedetailMethods,
    ...inventoryItemMethods,
    ...inventoryUnitMethods,
    ...requisitiondetailMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
